import PageComponent from '../PageComponent';

export default class AddressAutocomplete extends PageComponent {
    init() {
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            $.getScript('https://maps.googleapis.com/maps/api/js?libraries=geometry,places&key=AIzaSyDk3FxaqOHSQiAFjLse87dO9WlPYxCjf08', () => {
                this.ready();
            });
        } else {
            this.ready();
        }
    }

    ready() {
        let addressField = this.element.find('input[name="FullAddress"]'),
            countryField = this.element.find('select[name="Country"]'),
            autocomplete = this.createAutocomplete(addressField, countryField);

        autocomplete.setFields(['address_component']);

        countryField.on('change', () => {
            this.updateAutocomplete(autocomplete, countryField);
        });

        let extraFieldsToggle = this.element.find('.btn-link');
        extraFieldsToggle.on('click', () => {
            this.showExtraAddressFields();
        });

        autocomplete.addListener('place_changed', () => {
            this.fillInAddress(autocomplete)
        });
    }

    createAutocomplete(addressField, countryField) {
        let options = this.getCountryRestriction(countryField);
        return new google.maps.places.Autocomplete(addressField[0], options);
    }

    updateAutocomplete(autocomplete, countryField) {
        let options = this.getCountryRestriction(countryField);
        autocomplete.setOptions(options);
    }

    getCountryRestriction(countryField) {
        let country = countryField.val();
        if (!country || country === '') {
            country = 'nz';
        }
        return {
            types: ['geocode'],
            componentRestrictions: {country: country}
        };
    }

    showExtraAddressFields() {
        let extraFields = this.element.find('.extra-address-fields');
        if (!extraFields.hasClass('show')) {
            extraFields.addClass('show');
        }
    }

    fillInAddress(autocomplete) {
        let place = autocomplete.getPlace(),
            extraFields = this.element.find('.extra-address-fields'),
            extraInputs = extraFields.find('input');

        // always reset before re-populating
        extraInputs.each(function () {
            $(this).val('');
        });

        if (place) {
            let addressData = [],
                AddressField = extraFields.find('input[name="Address"]'),
                SuburbField = extraFields.find('input[name="Suburb"]'),
                CityField = extraFields.find('input[name="City"]'),
                StateField = extraFields.find('input[name="State"]'),
                PostCodeField = extraFields.find('input[name="PostalCode"]');

            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0],
                    value = place.address_components[i]['long_name'];
                addressData[addressType] = value;
            }

            let premise = typeof (addressData['premise']) !== 'undefined' ? addressData['premise'] : '';
            let street = typeof (addressData['street_number']) !== 'undefined' ? addressData['street_number'] : '';
            let route = typeof (addressData['route']) !== 'undefined' ? addressData['route'] : '';
            let suburb = typeof (addressData['sublocality_level_1']) !== 'undefined' ? addressData['sublocality_level_1'] : '';
            let city = typeof (addressData['locality']) !== 'undefined' ? addressData['locality'] : '';
            let state = typeof (addressData['administrative_area_level_1']) !== 'undefined' ? addressData['administrative_area_level_1'] : '';
            let code = typeof (addressData['postal_code']) !== 'undefined' ? addressData['postal_code'] : '';
            const streetAddress = premise + ' ' + street + ' ' + route;

            if(!state){
                state = suburb;
                suburb = '';
            }

            if(!city){
                city = state;
            }

            AddressField.val(streetAddress.trim());
            SuburbField.val(suburb);
            CityField.val(city);
            StateField.val(state);
            PostCodeField.val(code);

            this.showExtraAddressFields();
        }
    }
}
